import React from "react";

/**
 * WizardContext - Central state management for the wizard
 * Stores: current page, inputManifest (reference data), emittedManifest (output data), navigation state, etc.
 */
const WizardContext = React.createContext({
    currentPage: 0,
    setCurrentPage: () => {},
    pageCount: 0,
    canNext: false,
    canBack: false,
    canFinish: false,
    inputManifest: {},
    emittedManifest: {},
    setEmittedManifest: () => {},
    runtimeVariables: {},
    setRuntimeVariables: () => {},
    title: "Wizard",
    moveNext: () => {},
    moveBack: () => {},
    handleClose: () => {},
    handleFinish: () => {},
    canClose: true,
    isFinishing: false,
});

export default WizardContext;
